import React from 'react';


const Loading = () => {
    return (
        <div style={{ height: '300px' }} className='w-100 flex justify-center items-center'>
            <button className="btn btn-square loading"></button>
        </div>
    );
};

export default Loading;